import {Component, Inject} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {UserInformationService} from '../../../services/user-information.service';
import {System} from '../../../models/system-overview.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

export interface DialogData {
    serialNumber: string;
    system: System;
    headEquipment: string;
    context: string;
    messageType: string;
}


@Component({
    selector: 'app-not-registrated-popup',
    templateUrl: 'not-registrated-popup.component.html',
    styleUrls: ['./not-registrated-popup.component.scss']
})
export class NotRegistratedPopupComponent {

    dataProtectionDeclarationUrl = environment.dataProtection.split('{b2x}');
    heatingSystemRegistrationEquiUrl = environment.heatingSystemRegistrationEqui;
    heatingSystemRegistrationSerialNumberUrl = environment.heatingSystemRegistrationSerialnumber;
    postalCode: string = '';

    constructor(
        public dialogRef: MatDialogRef<NotRegistratedPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public userInformationService: UserInformationService,
        private router: Router) {
    }

    close(): void {
        if (this.data.context === 'find-by-serialnumber') {
            this.router.navigate(['/list']);

        }
        this.dialogRef.close();
    }

    setPostalCode($event: any) {
        this.postalCode = $event.target.value;
    }
}
